import { Injectable } from '@angular/core';
import { ServicingBaseClass } from '@common/components';
import { CommonLibService } from '@lib/services';
import {
  GetDocumentListEmdStore,
  resetGetDocumentListEmd,
  selectGetDocumentListEmdIsFailureStatus,
  selectGetDocumentListEmdState,
  setGetDocumentListEmdFromApi,
} from '@common/store';
import { Store, select } from '@ngrx/store';
import { DefaultService as Api } from 'src/sdk-servicing/api/default.service';
import { Observable } from 'rxjs';
import { filter, map, withLatestFrom, zipWith } from 'rxjs/operators';
import { GetDocumentListEmdRequest, GetDocumentListEmdResponse } from 'src/sdk-servicing';

/**
 * S05-P011_領収書選択 EMDリスト取得APIとレスポンス管理ストアを操作するためのサービス
 *
 */
@Injectable()
export class GetDocumentListEmdStoreService extends ServicingBaseClass {
  private result$!: Observable<GetDocumentListEmdResponse | null>;
  private failure$!: Observable<boolean>;

  public get res$() {
    return this.result$;
  }

  constructor(private store: Store<GetDocumentListEmdStore>, private api: Api, private common: CommonLibService) {
    super();
    this.result$ = this.store.pipe(
      select(selectGetDocumentListEmdState),
      map((state) => state.model)
    );
    this.failure$ = this.store.pipe(
      select(selectGetDocumentListEmdIsFailureStatus),
      filter((isFailure) => isFailure)
    );
  }

  /**
   * APIの結果をハンドリングします。
   * @param responseHandler APIコールが成功した場合のハンドラ
   * @param errorHandler 失敗した場合のハンドラ
   * @param observableWith APIコールと一緒にsubscribeするObservable (有料サービスマスタのキャッシュなど)
   */
  setupHandler<T>(
    responseHandler: (response: GetDocumentListEmdResponse, responseWith: T) => void,
    errorHandler: (apiErrorCode?: string) => void,
    observableWith: Observable<T>
  ) {
    this.subscribeService(this.result$.pipe(filter(Boolean), zipWith(observableWith)), (result) => {
      responseHandler(result[0], result[1]);
    });
    this.subscribeService(
      this.failure$.pipe(
        withLatestFrom(this.common.apiErrorResponseService.getApiErrorResponse$(), (_, state) => state)
      ),
      (model) => {
        const errors = model?.errors;
        const apiErrorCode = errors && errors.length ? errors[0].code : undefined;

        errorHandler(apiErrorCode);
      }
    );
  }

  callApi(req: GetDocumentListEmdRequest) {
    const call = this.api.ordersGetDocumentListEmdPost(req);
    this.store.dispatch(setGetDocumentListEmdFromApi({ call }));
  }
  /**
   * ストアを空にします。
   */
  clearStore(): void {
    this.store.dispatch(resetGetDocumentListEmd());
  }

  override destroy(): void {}
}
